import Vue from '../node_modules/vue/dist/vue.common';
Vue.config.devtools = true
import MessasgeBus from './message-bus';
import ATDSuperTable from './lib/AtdSuperTable.js';

const COOKIE_KEY = 'part-search-cart';

const PartSearch = function(elId) {
    if(!document.getElementById(elId)) {
        return null;
    }

    return new Vue({
        el: `#${elId}`,
        data() {
           return {
                parts: {
                  results: []
                },
                is_mounted: false,
                filter_options: {
                    makes: [],
                    divisions: [],
                    equipment_types: [],
                    models: [],
                    he_part_nums: [],
                    oem_part_nums: [],
                    flags: [],
                    domex: []
                },
                filter_options_base: {
                    makes: [],
                    lowercase_makes: [],
                    divisions: [],
                    equipment_types: [],
                    models: [],
                    he_part_nums: [],
                    oem_part_nums: [],
                    flags: [],
                    domex: []
                },
                get_models: {
                },
                // get_models_lokomo: {
                //     models: []
                // },
                // get_models_terex: {
                //     models: []
                // },
                // get_models_ok: {
                //     models: []
                // },
                // get_models_komatsu: {
                //     models: []
                // },
                // get_models_liebherr: {
                //     models: []
                // },
                // get_models_metso: {
                //     models: []
                // },
                // get_models_nordberg: {
                //     models: []
                // },
                // get_models_caterpillar: {
                //     models: []
                // },
                // get_models_hitachi: {
                //     models: []
                // },
                // get_models_epiroc: {
                //     models: []
                // },
                search: {
                    makes: '',
                    divisions: '',
                    equipment_types: '',
                    models: '',
                    he_part_nums: '',
                    oem_part_nums: '',
                    results_per_page: 20,
                    page: 0,
                    page_offset: 0,
                    keyword: '',
                    flags: '',
                    domex: 1
                },
                is_results_fading: false,
                is_fading: false,
                is_loading: false,
                detail: null,
                selected_parts: [],
                part_list: [],
                cart_id:'',
                cart_parts: [],
                relatedParts: []
            }
        },
        watch: {
          detail(newVal, oldVal) {
            if (newVal !== null) {
              const {make, model} = newVal
              this.getParts({make: make[0], model}).then((response) => {
                this.relatedParts = response.results
              })
            } else {
              this.relatedParts = []
            }
          }
        },
        computed: {
          additionalParts() {
            return Array.from(this.relatedParts).filter(part => {
              return this.detail.he_part_num[0] != part.he_part_num[0]
            })
          },
            page_count() {
              const partsPerPage = this.search.results_per_page || 20;
              const totalResults = this.parts.results.length || 0;
                return  Math.ceil(totalResults / partsPerPage);
            },

            visible_results() {
                if(!this.parts || !this.parts.results) {
                    return [];
                } else {
                    window.setTimeout(() => {
                        if(document.getElementById('part-table')) {
                            new ATDSuperTable(document.getElementById('part-table'));
                        }
                    }, 10);

                    return this.parts.results;
                }
            },
        },
        created() {
            let message_bus = MessasgeBus.getInstance();
            if(message_bus) {
                message_bus.$on('part-string', (e) => { this.setPartString(e); });
            }
        },
        mounted() {
            let message_bus = MessasgeBus.getInstance();
            if(message_bus) {
                message_bus.$on('part-string', (e) => { this.setPartString(e); });
            }

            let cookie_cart_id = this.checkCartCookie();

            // if cart_id is set load cart from api
            if(cookie_cart_id) {
                this.loadCart(cookie_cart_id).then((results) => {
                    if(results && results.cart_id) {
                        this.cart_id = results.cart_id;
                    }

                    if(results && results.parts) {
                        this.cart_parts = results.parts;
                        this.selected_parts = [];
                        this.cart_parts.forEach(part => {
                            this.selected_parts.push(part.he_part_num);
                        });

                        // this.updatePartsField();
                    }

                });
            }

            this.getFilterOptions().then( filter_options => {
                this.filter_options = Object.assign({}, filter_options);
                this.filter_options_base = Object.assign({}, filter_options);
            });

            this.is_mounted = true;

            this.handlePopState(false);

            window.onpopstate = () => {
                this.handlePopState(true);
            }


        },
        methods: {
            checkCartCookie(cookie_key = COOKIE_KEY) {
                var match = document.cookie.match(new RegExp('(^| )' + cookie_key + '=([^;]+)'));
                if (match) {
                    return match[2];
                }

                return null;
            },
            loadCart(cart_id) {
                return fetch(`/wp-json/atd/part-search-cart/get/${cart_id}`, {
                    method: 'GET'
                })
                .then(response => response.json());
            },
            resetForm(e=false, restrict=false) {
                e && e.preventDefault();
                this.getFilterOptions().then( filter_options => {
                    this.filter_options = Object.assign({}, filter_options);
                });

                if(!this.filter_options) {
                    //console.log(this.filter_options);
                    this.filter_options = this.filter_options_base;
                }

                this.parts = { results: []};
                if(restrict == 'keyword' || restrict == false) {
                    this.search.makes = '';
                }
                this.search.divisions = '';
                this.search.equipment_types = '';
                this.search.models = '';
                this.search.he_part_nums = '';
                this.search.oem_part_nums = '';
                if(restrict == 'make' || restrict == false) {
                    this.search.keyword = '';
                }
                this.detail = null;
            },
            itemInCart(item) {
                // console.log(this.part_list.includes(item[0]));
                return this.part_list.includes(item[0]);
                // console.log(part_search_cart.$refs.isPartInCart(item[0]));
            },
            setPartString(e) {
                this.part_list = e.split(',');
                // console.log(this.part_list)
                // this.selected_parts = this.part_list.map(item => Array(item));
            },
            handlePopState(is_popstate) {
                /* check url params for search terms */

                let url_params = new URLSearchParams(window.location.search);
                // console.log(window.location.href);
                let should_search = false;

                const urlParamChecks = {
                  make: 'makes',
                  division: 'divisions',
                  equipment_type: 'equipment_types',
                  model: 'models',
                  hepi: 'he_part_nums',
                  oem_part_num: 'oem_part_nums',
                  keyword: 'keyword',
                  flag: 'flags'
                }

                Object.keys(urlParamChecks).forEach((key) => {
                  if(url_params.has(key)) {
                    Object.assign(this.search, {[urlParamChecks[key]]: url_params.get(key)});
                      should_search = true;
                  } else if (is_popstate) {
                    Object.assign(this.search, {[urlParamChecks[key]]: ''});
                  }
                })

                // if(url_params.has('make')) {
                //     this.search.makes = url_params.get('make');
                //     should_search = true;
                // } else if (is_popstate) {
                //     this.search.makes = '';
                // }

                // if(url_params.has('division')) {
                //     this.search.divisions = url_params.get('division');
                //     should_search = true;
                // } else if (is_popstate) {
                //     this.search.divisions = '';
                // }

                // if(url_params.has('equipment_type')) {
                //     this.search.equipment_types = url_params.get('equipment_type');
                //     should_search = true;
                // } else if (is_popstate) {
                //     this.search.equipment_types = '';
                // }

                // if(url_params.has('model')) {
                //     this.search.models = url_params.get('model');
                //     should_search = true;
                // } else if (is_popstate) {
                //     this.search.models = '';
                // }

                // if(url_params.has('hepi')) {
                //     this.search.he_part_nums = url_params.get('hepi');
                //     should_search = true;
                // } else if (is_popstate) {
                //     this.search.he_part_nums = '';
                // }

                // if(url_params.has('oem_part_num')) {
                //     this.search.oem_part_nums = url_params.get('oem_part_num');
                //     should_search = true;
                // } else if (is_popstate) {
                //     this.search.oem_part_nums = '';
                // }

                // if(url_params.has('keyword')) {
                //     this.search.keyword = url_params.get('keyword');
                //     should_search = true;
                // } else if (is_popstate) {
                //     this.search.keyword = '';
                // }

                // if(url_params.has('flag')) {
                //     this.search.flags = url_params.get('flag');
                //     should_search = true;
                // } else if (is_popstate) {
                //     this.search.flags = '';
                // }


                const urlPieces = window.location.href.split('/').filter((item) => item.length > 0);
                let key = urlPieces.findIndex(($key) => $key == 'parts' );
                let part_id = false;
                if(key !== -1 && urlPieces.length > key+1 && !urlPieces[key+1].includes('?')) {
                    part_id =  urlPieces[key+1];
                }


                if(url_params.has('part') || part_id ) {
                    if (!part_id) {
                        let newUrl = '/parts/'+ url_params.get('part') +'/';
                        document.location.href = newUrl;
                    }
                    // console.log({url_params, part_id, key})
                
                    // part_id = url_params.get('part');

                    this.is_loading = true;

                    
                    window.setTimeout(() => {
                        window.scrollTo(0, 0);
                        this.getPart(part_id).then(response => {
                            Object.assign(this.search, {current_page: 0});
                            this.is_loading = false;
                            this.detail = response.results[0];


                            if (typeof response.results[0] !== 'undefined')
                            {
                                this.check_filters(response.results);
                            }



                            // document.getElementsByTagName('title')[0].innerText = this.makeTitleText(this.detail);

                        });
                    }, 500);
                    // window.setTimeout(() => {
                    //     window.scrollTo(0, 0);
                    //     this.getParts().then(response => {
                    //         this.check_filters(response.results);
                    //         Object.assign(this.parts, response);
                    //     });
                    // }, 500);

                }//end

                if(should_search || is_popstate) {
                    this.is_loading = true;
                    
                    window.setTimeout(() => {
                      window.scrollTo(0, 0);
                      this.getParts().then(response => {
                            this.check_filters(response.results);
                            this.parts = response;
                            this.search.current_page = 0;
                            this.detail = null;
                            this.is_loading = false;
                        });
                    }, 500);
                }

            },

            onSearch(e, make_search=false, reset_make=false) {
                e && e.preventDefault();

                // let key = window.location.href.split('/').findIndex(($key) => $key == 'part' );
                // let part_id = false;
                // if(key !== -1) {
                //     part_id =  window.location.href.split('/')[key+1];
                // }
                // console.log(part_id);
                // if(part_id) {
                //     window.location = '/parts/';
                // }

                this.is_loading = true;

                let reset = this.setURLSearchParams(make_search);
                // console.log('onSearch');

                // console.log(reset);
                if(reset) {
                    // console.log('hit');
                    this.resetForm(e, reset);
                    this.is_loading = false;
                    window.setTimeout(() => {
                        window.scrollTo(0, 0);
                        this.getParts().then(response => {
                            if(reset == 'keyword') {
                                this.filter_options.divisions = this.filter_options_base.divisions;
                                this.filter_options.equipment_types = this.filter_options_base.equipment_types;
                                this.parts = response;
                            } else if(response.results.length == 0) {
                                this.getFilterOptions().then( filter_options => {
                                    this.filter_options = Object.assign({}, filter_options);
                                });
                            }
                            this.search.current_page = 0;
                            this.detail = null;
                            this.is_loading = false;
                            this.search.page_offset = 0;
                        });
                    }, 500);
                }else{
                    // this.resetForm(e, reset);
                    window.setTimeout(() => {
                        window.scrollTo(0, 0);
                        this.getParts().then(response => {
                            // this.check_filters(response.results, reset_make);
                            Object.assign(this.parts, response);
                            Object.assign(this.search, {current_page: 0, page_offset: 0});
                            this.detail = null;
                            this.is_loading = false;
                        });
                    }, 500);
                }
            },

            check_filters(array, reset_make=false) {
                let that = this;
                let name = this.search.makes.toLowerCase();
                Object.assign(this.filter_options, {divisions: [], equipment_types: []});
                Object.assign(this.filter_options_base, {lowercase_makes: []});

                if((name.length > 0 && this[`get_models`][`${name}`] === undefined) || reset_make) {
                    this[`get_models`][`${name}`] = [];
                }

                if(!this.search.makes) {
                  Object.assign(this.filter_options, {makes: []});
                }

                this.filter_options_base.lowercase_makes = that.filter_options_base.makes.map(v => v.toLowerCase());
                // this.filter_options_base.divisions = that.filter_options_base.makes.map(v => v.toLowerCase());

                array.forEach(value => {
                  const makes = Array.from(value.make).filter((v) => v !== null && v !== '');
                  const divisions = Array.from(value.division).filter((v) => v !== null && v !== '');
                  const equipmentTypes = Array.from(value.equipment_type).filter((v) => v !== null && v !== '');

                  // console.log({makes, divisions, equipmentTypes})

                  if (divisions.length > 0) {
                    if(that.filter_options_base.divisions.includes(divisions[0]) && this.filter_options.divisions.indexOf(divisions[0]) === -1) {
                        that.filter_options.divisions.push(divisions[0]);
                    }
                  }

                  if (equipmentTypes.length > 0) {
                    if(that.filter_options_base.equipment_types.includes(equipmentTypes[0]) && this.filter_options.equipment_types.indexOf(equipmentTypes[0]) === -1) {
                        that.filter_options.equipment_types.push(equipmentTypes[0]);
                    }
                  }
                    
                  if(makes.length > 0) {
                      if(this.filter_options_base.lowercase_makes.includes(makes[0].toLowerCase()) && this.filter_options.makes.indexOf(makes[0]) === -1) {
                          that.filter_options.makes.push(makes[0]);
                      }
                  }

                  if(name.length > 0) {
                      value.model.forEach((item) => {
                          // if(that.filter_options_base.models.includes(item) && that[`get_models`][`${name}`].indexOf(item) === -1) {
                              if(!that[`get_models`][`${name}`].includes(item)) {
                                  that[`get_models`][`${name}`].push(item);
                              }
                          // }
                      });
                  }
                });
                if (!that.filter_options.makes.includes('Other')) {
                    that.filter_options.makes.push('Other');
                }



                if(that.filter_options.equipment_types.length) {
                    that.filter_options.equipment_types.sort();
                }
                if(that.filter_options.makes.length) {
                    that.filter_options.makes.sort();
                }
                if(that[`get_models`][`${name}`]) {
                    that[`get_models`][`${name}`].sort();
                }
            },

            getModels(make) {
                return fetch(`/wp-json/atd-part-search/v1/options_per_make?make=${make}`, {
                    method: 'GET'
                })
                .then(response => response.json());
            },

           onChangePage(e, page) {
               e && e.preventDefault();
               if(page >= 0 && page <= this.page_count) {
                   this.is_results_fading = true;

                    window.setTimeout(() => {
                        let results_offset = document.getElementById('results').offsetTop;
                        window.scrollTo(0, results_offset);

                        // if(this.page_count == page){
                        //     page -= 1;
                        // }

                        this.search.page = page;
                        this.search.current_page = page;
                        this.search.page_offset = page * this.search.results_per_page;

                        this.is_results_fading = false;
                    }, 300);
                }
           },

           setURLSearchParams(make_search) {
                let param_string = window.location.origin + '/parts/' + '?';
                // console.log(window.location.origin);
                // console.log(param_string);

                this.updatePageTitle();


                let check = {
                    make: false,
                    division: false,
                    equipment_type: false,
                    models: false,
                    he_part_num: false,
                    oem_part_nums: false,
                    keyword: false,
                    flag: false
                }

                // for(let item in this.search) {
                //     console.log(item);
                // }

                if(make_search) {
                    this.search.keyword ='';
                    this.search.models = '';
                }

                if(this.search.keyword && !make_search) {
                    this.search.makes = '';
                    param_string += 'keyword=' + encodeURIComponent(this.search.keyword) + '&';
                    window.history.pushState(null, null, param_string.slice(0, -1))
                    return 'keyword';
                    check.keyword = true;
                }

                if(this.search.makes && make_search) {
                    this.search.keyword = '';
                    param_string += 'make=' + encodeURIComponent(this.search.makes) + '&';
                    // check.make = true;
                    // if(this.visible_results.length > 0 ) {
                    //     if(this.visible_results[0].make[0] != this.search.makes){
                    //         // console.log('new make');
                    //         window.history.pushState(null, null, param_string.slice(0, -1))
                    //         return 'make';
                    //     }
                    //     // if(this.search.keyword) {
                    //     //     console.log('new make');
                    //     //     window.history.pushState(null, null, param_string.slice(0, -1))
                    //     //     return 'make';
                    //     // }
                    // }
                }else if(this.search.makes) {
                    param_string += 'make=' + encodeURIComponent(this.search.makes) + '&';
                }

                if(this.search.divisions) {
                    param_string += 'division=' + encodeURIComponent(this.search.divisions) + '&';
                    check.division = true;
                }

                if(this.search.equipment_types) {
                    param_string += 'equipment_type=' + encodeURIComponent(this.search.equipment_types) + '&';
                    check.equipment_type = true;
                }

                if(this.search.models) {
                    param_string += 'model=' + encodeURIComponent(this.search.models) + '&';
                    check.models = true;
                }

                if(this.search.he_part_nums) {
                    param_string += 'hepi=' + encodeURIComponent(this.search.he_part_nums) + '&';
                    check.he_part_num = true;
                }

                if(this.search.oem_part_nums) {
                    param_string += 'oem_part_num=' + encodeURIComponent(this.search.oem_part_nums) + '&';
                    check.oem_part_nums = true;
                }

                if(this.search.flags) {
                    let flag_param = '';
                    if(this.search.flags) {
                        flag_param = 'S';
                    }
                    param_string += 'flag=' + encodeURIComponent(flag_param) + '&';
                    check.flag = true;
                }

                if(this.search.domex) {
                    let domex_param = '1';
                    // if(this.search.domex) {
                        // param_string += 'domex=1&';
                    // }
                    this.domex = true;

                }

                window.history.pushState(null, null, param_string.slice(0, -1))
                if(param_string[param_string.length-1] === '?') {
                    return true; //reset form if nothing selected
                }
                return false;

            },

            updatePageTitle() {
                let title = [];
                if(this.search.divisions) {
                    title.push(this.search.divisions);
                }

                if(this.search.makes) {
                    title.push(this.search.makes);
                }

                if(this.search.equipment_types) {
                    title.push(this.search.equipment_types);
                }

                title.push('Parts for Sale');
                document.title = title.join(' ');
            },

            getParts(args = {}) {
              if (Object.keys(args).length <= 0) {
                const {equipment_types, makes, models, divisions, oem_part_nums, he_part_nums, keyword} = this.search
                const searchArgs = {
                  flag: this.search.flags ? 'S': '',
                  make: makes,
                  equipment_type: equipment_types,
                  model: models,
                  division: divisions,
                  oem: oem_part_nums,
                  hepi: he_part_nums,
                  keyword
                }

                args = Object.assign(args, searchArgs)
              }
                const params = new URLSearchParams(args)

                const requestUri = `/wp-json/atd-part-search/v1/search-parts/?${params}`
                return fetch(requestUri).then(response => response.json());
            },

            getPart(id) {
                return fetch(`/wp-json/atd-part-search/v1/part/${id}`).then(response => response.json());
            },

            getFilterOptions() {
                return fetch('/wp-json/atd-part-search/v1/options', {
                    method: 'GET'
                })
                .then(response => response.json());
            },


            setSearchParams() {
                let urlParams = new URLSearchParams();

                Object.keys(this.search).forEach((key) => {
                    if(this.search[key]) {
                        urlParams.append(key, this.search[key]);
                    }
                });

                return(`?${urlParams.toString()}`);
            },

            onDetailView(e, part) {
                if((e && e.target && e.target.href && part) || (e && e.target.dataset && e.target.dataset.tooltip)) {
                    return;
                }



                e && e.preventDefault();
                //this.is_fading = true;



                window.setTimeout(() => {
                    window.scrollTo(0, 0);

                    if(part) {
                        //Redirect to new url
                        let newUrl = '/parts/'+ part.he_part_num +'/';
                        document.location.href = newUrl;
                        // console.log(newUrl);
                        // console.log('here');

                        //this.detail = part;
                        //this.search.part = part.he_part_num;
                        //window.history.pushState({}, `Search Results`, `${this.setSearchParams()}`);
                    }
                    else {
                        history.back();
                        //this.search.part = '';
                        //window.history.pushState({}, `Search Results`, this.setSearchParams());
                        //this.onSearch();
                        //this.detail = null;
                    }

                    this.is_fading = false;



                }, 300);
            },

            makeH1Text(part) {
                // Hitachi EX1200-6 Hydraulic Excavator For Sale
                // return `${part.make[0]} ${part.model[0]} ${part.equipment_type[0]} For Sale`;
                return `H-E Parts ${part.he_part_num[0]} Details`;
            },

            makeTitleText(part) {
                // Hitachi EX1200-6 Hydraulic Excavator For Sale
                // return `${part.make[0]} ${part.model[0]} ${part.equipment_type[0]} Parts`;
                console.log(part.equipment_type);
                let equipment_type = part.equipment_type[0] ? part.equipment_type[0] : '';
                let part_num = '';
                if(part.oem_part_num[0] == null) {
                    part_num = part.he_part_num[0] != null ? part.he_part_num[0] : '';
                }else{
                    part_num = part.oem_part_num[0]
                }
                // return `Part ${part.make[0]} ${equipment_type} ${part.model[0]} Part ${part_num} For Sale`;
                document.getElementsByTagName('title')[0].innerText = `Part ${part.make[0]} ${equipment_type} ${part.model[0]} Part ${part_num} For Sale`;
            },

            additionalPartsLine(part) {
                let equipment_type = part.equipment_type[0] ? part.equipment_type[0] : '';
                let part_num = '';
                if(part.oem_part_num[0] == null) {
                    part_num = part.he_part_num[0] != null ? part.he_part_num[0] : '';
                }else{
                    part_num = part.oem_part_num[0]
                }
                return `Additional ${part.make[0]} ${part.model[0]} Parts For Sale`;
                // return `${part.make[0]} ${equipment_type} ${part.model[0]} Part ${part_num} Description`;
            },

            makeHeadline(part) {
                // "{{Make}} {{EquipmentType}} {{Model}} Part {{OEM Part Number}} For Sale
                let equipment_type = part.equipment_type[0] ? part.equipment_type[0] : '';
                let part_num = '';
                if(part.oem_part_num[0] == null || part.oem_part_num[0] == '') {
                    part_num = part.he_part_num[0] != null ? 'H-E Part ' +part.he_part_num[0] : '';
                }else{
                    part_num = `Part ${part.oem_part_num[0]}`;
                }
                let make_text = '';
                if(part.make[0]) {
                    make_text = ` for ${part.make[0]}`
                }
                // document.getElementsByTagName('title')[0].innerText = `${part_num} ${make_text} ${equipment_type} ${part.model[0]} For Sale`;
                // let metaText = this.makeMetaDescription(part);
                // let metaTag = document.createElement('meta')
                // metaTag.setAttribute('name', 'description');
                // metaTag.setAttribute('content', metaText);
                // metaTag.setAttribute('id', 'metatag');
                // document.getElementsByTagName('head')[0].appendChild(metaTag);
                return `${part_num} ${make_text} ${equipment_type} ${part.model[0]} For Sale`;
            },

            makeMetaDescription(part) {
                if(document.getElementById('metatag')) {
                    document.getElementById('metatag').remove(); //reset metatag
                }
                // H-E Parts has a MakeGoesHere + ModelGoesHere + EquipmentTypeGoesHere for sale. This part has the OEM part number(s) OEMPartNumber1GoesHere, OEMPartNumber2GoesHere, OEMPartNumber3GoesHere. The description is DescriptionGoesHere.
                return `H-E Parts has ${part.make[0]} ${part.model[0]} ${part.equipment_type[0]} parts available. This part has the OEM part number(s) ${part.oem_part_num.join(', ')}. ${part.description.join(' ')}`;
            },

            makeSeoText(part) {

                // if(part.oem_part_num[0] == null || part.oem_part_num[0] == '') {
                    const mnf_part_no = part.he_part_num[0];
                // }else {
                    // mnf_part_no = part.oem_part_num[0];
                // }

                // const mnf_part_no = ((part.oem_part_num[0] != null || part.oem_part_num[0] != '') ? part.oem_part_num[0] : part.he_part_num[0]);
                const alt_mfg_part_nos_list = part.oem_part_num.length > 0 ? part.oem_part_num.filter((v, i) => i > 0) : [];
                const alt_mfg_part_nos = alt_mfg_part_nos_list.join(', ');
                let equipment_type = part.equipment_type[0] ? part.equipment_type[0] : '';
                let equipment_type_lower = equipment_type.toLowerCase();
                // console.log(alt_mfg_part_nos_list);

                let availability = part.availability[0].toLowerCase();
                let format_availability = '';
                if(availability == 'usa'){
                    format_availability = 'USA';
                }else if(availability && availability.length > 0) {
                    format_availability = availability[0].toUpperCase() + availability.slice(1);
                }
                let full_desc = part.description[0].toLowerCase() + ' ';
                let word = [];
                // console.log(part.description[1].split(' ').length);
                if(part.description[1]) {
                    if(part.description[1].split(' ').length > 1) {
                        word = part.description[1].split(' ').map(function(i) {
                            // console.log(i);
                            if (i.length > 0) {
                                return i[0].toUpperCase() + i.slice(1);
                            }

                        });
                    }
                }

                full_desc += word.join(' ');
                let status_text = ''
                status_text += `This ${part.make[0]} ${part.division[0]} part ${mnf_part_no}`;
                if(part.condition[0] !== '' && part.availability[0].length) {
                    status_text += ` is in ${part.condition[0]} condition.`
                    status_text += ` It is currently stored in a facility in ${format_availability}.`
                }else if(part.condition[0] === '' && part.availability[0].length) {
                    status_text += ` is stored in a facility in ${format_availability}.`
                }else if(part.condition[0] !== '' && part.availability[0].length == 0) {
                    status_text += ` is in ${part.condition[0]} condition.`
                }else if(part.condition[0] === '' && part.availability[0].length == 0){
                    status_text = '';
                }

                // console.log(full_desc);

                // H-E Parts has {{Make}} part number {{Manufacturer Part Number}} for sale <IF there’s another part number>(which also has the part number(s) {{any additional Manufacturer Part Numbers}})<END IF>. {{Manufacturer Part Number}} is a {{Description}} used on the {{Make}} {{Equipment Type}} {{Model}}. The {{Make}}  {{Manufacturer Part Number}} is typically used in <IF it’s a cooling part>Cooling operations on mining, crushing and construction projects<END IF><ELSE IF it’s a Dom-Ex part>mining projects<END IF>.
                // This {{Make}} {{Equipment Type}} part {{Manufacturer Part Number}} is in {{Item Status}}condition. It is currently stored in a facility in {{Availability}}. H-E Parts typically delivers parts to customers within 30 days to anywhere in the world. To inquire about this product, add it to your cart, and fill out the brief contact form. An H-E Parts sales representative will respond to your inquiry within two business days.


                let status = null;

                if (part.condition || part.item_status)
                {
                        if (part.condition[0])
                        {
                            if (part.condition[0].length > 1)
                            {
                                status = part.condition[0].toLowerCase();
                            }
                        } else if (part.item_status[0]) {
                            if (part.item_status[0].length > 1)
                            {
                                status = part.item_status[0].toLowerCase();
                            }
                        }
                }

                return [
                    `H-E Parts has ${part.make[0]} part number ${mnf_part_no} for sale${alt_mfg_part_nos_list.length > 0 ? ` which also has the part number${alt_mfg_part_nos_list.length > 1 ? 's' : ''} ${alt_mfg_part_nos}` : ''}. ${part.make[0]} ${equipment_type} ${part.model[0]} is a ${full_desc} used on the ${part.make[0]} ${part.model[0]} ${part.equipment_type[0]}. The ${part.make[0]}  ${mnf_part_no} is typically used in ${part.division[0] === 'Cooling' ? 'cooling operations on mining, crushing and construction projects' : 'mining projects'}.`,
                    `${status_text} H-E Parts typically delivers parts to customers within 30 days to anywhere in the world. To inquire about this product, add it to your cart, and fill out the brief contact form. An H-E Parts sales representative will respond to your inquiry within two business days.`
                ];

            },

            makeCanonicalTag(part) {
                document.querySelector('link[rel="canonical"]').setAttribute('href',`${window.location.origin}/parts/?part=${part.he_part_num[0]}`);
            },

            addToPartSearchCart(e, part) {
                e && e.preventDefault();
                //console.log('add to cart');
                //console.log(part);
                let message_bus = MessasgeBus.getInstance();
                if(message_bus) {
                    message_bus.$emit('part-added', [part], true);
                }
            },

            isDomex(part) {
                return part.division[0] == "Dom-Ex";
            },

            addMultipleParts(e) {
                e && e.preventDefault();
                if(this.selected_parts.length === 0 ) {
                    return false;
                }

                let parts = [];
                this.parts.results.forEach((part) => {
                    if(this.selected_parts.indexOf(part.he_part_num) >= 0) {
                        parts.push(part);
                    }
                })

                let message_bus = MessasgeBus.getInstance();
                if(message_bus) {
                    message_bus.$emit('part-added', parts, true);
                    // this.selected_parts = [];
                }
            },

            addMultiplePartsNoModal(e) {
                e && e.preventDefault();
                if(this.selected_parts.length === 0 ) {
                    return false;
                }

                let parts = [];
                this.parts.results.forEach((part) => {
                    if(this.selected_parts.indexOf(part.he_part_num) >= 0) {
                        parts.push(part);
                    }
                })

                let message_bus = MessasgeBus.getInstance();
                if(message_bus) {
                    message_bus.$emit('part-added', parts, true);
                    // this.selected_parts = [];
                }
            },

            onSelectAll(e) {
                e && e.preventDefault();

                if(this.selected_parts.length === this.visible_results.length) {
                    this.selected_parts = [];
                }
                else {
                    this.selected_parts = [];
                    this.visible_results.forEach(part => {
                        this.selected_parts.push(part.he_part_num);
                    });
                }
            },

            removeFromPartSearchCart(e, part) {
                e && e.preventDefault();

                let message_bus = MessasgeBus.getInstance();
                if(message_bus) {
                    message_bus.$emit('part-removed', part);
                }
            },

            getItemType(flag) {
                let map = {
                    "W": "Standard",
                    "S": "Service Exchange"
                }
                return map[flag.trim()];
            },
        }
    });
};

export {PartSearch as default}



// WEBPACK FOOTER //
// ./js/part-search.js